<template>
  <div class="p-4 border-b border-gray-200 bg-white">
    <h4 class="text-lg font-semibold flex justify-between mb-2">Add google font</h4>

    <div>
      <label for="email" class="block text-sm font-medium text-gray-700">Font family</label>
      <div class="relative mt-1 rounded-md shadow-sm">
        <input
          v-model="fontFamily"

          type="text"
          name="email"
          id="email"
          class="block w-full border-gray-300 rounded-md pr-10 focus:outline-none sm:text-sm duration-150"
          :class="[loading && '!border-blue-600 focus:ring-blue-600', notFound && '!border-red-600 focus:ring-red-600', success && '!border-green-600 focus:ring-green-600']"
          placeholder="e.g: Poppins"
        >

        <div v-if="loading || notFound || success" class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <svg v-if="loading" class="animate-spin h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <svg v-else-if="notFound" class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
          </svg>
          <svg v-else-if="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>
      <p v-if="notFound || success" class="mt-2 text-sm">
        <span v-if="notFound" class="text-red-600">
          Font family not found. Please try another one.
        </span>
        <span v-else-if="success" class="text-green-600">
          Font family found and selected!
        </span>
      </p>
    </div>
  </div>
</template>

<script>

const throttle = function(callback, delay) {
  let throttleTimeout = null
  let planDispatch = null
  let storedEvent = null
  const throttledEventHandler = function(event) {
    storedEvent = event
    const shouldHandleEvent = !throttleTimeout
    if (shouldHandleEvent) {
      callback.apply(this, [])
      storedEvent = null
      throttleTimeout = setTimeout(() => {
        throttleTimeout = null

        if (storedEvent) {
          throttledEventHandler.apply(this, [storedEvent])
        }
      }, delay)
    } else if (throttleTimeout && !planDispatch) {
      if (planDispatch) clearTimeout(planDispatch)
      planDispatch = setTimeout(() => {
        planDispatch = null

        throttledEventHandler.apply(this, [])
      }, delay)
    }
  }

  return throttledEventHandler
}

const capitalize = word => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
const capitalizeSentence = sentence => sentence.split(" ").map(word => capitalize(word)).join(" ")
const ID = "FONT_CHECK"

import { mapGetters } from "vuex"

export default {
  data() {
    return {
      fontFamily: "",

      loading: false,
      notFound: false,
      success: false,
      initialized: false,
    }
  },
  created() {
    console.log(this.readyToInitialize, this.config, this.website, this.initialized)
    this.readyToInitialize && this.initialize()
  },
  beforeDestroy() {
    this.removeOldLink()
  },
  methods: {
    initialize() {
      this.initialized = true
      const theme = this.config && this.config.tailwindConfig
      if (theme && theme.fontFamily && theme.fontFamily.sans && theme.fontFamily.sans[0]) {
        this.fontFamily = theme.fontFamily.sans[0]
      }
    },
    removeOldLink() {
      const oldLink = document.getElementById(ID)
      if (oldLink) oldLink.remove()
    },
    fetchFont: throttle(async function() {
      if (!this.fontFamily) return;
      this.success = false
      this.loading = true
      this.notFound = false

      this.removeOldLink()
      const link = document.createElement('link')
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.id = ID

      link.href = this.fontFamilyUri
      link.onload = () => {
        this.success = true
        this.loading = false
      }
      link.onerror = () => {
        this.notFound = true
        this.loading = false
      }
      document.head.appendChild(link)
    }, 500)
  },
  computed: {
    ...mapGetters({
      config: 'editor/config',
      website: 'editor/website',
    }),

    readyToInitialize() {
      return this.config && this.website && !this.initialized
    },
    capitalizedFontFamily() {
      return capitalizeSentence(this.fontFamily)
    },
    fontFamilyUri() {
      return this.fontFamily && `https://fonts.googleapis.com/css2?family=${this.capitalizedFontFamily.replace(/\s/g, "+")}:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap`
    },
  },
  watch: {
    readyToInitialize() {
      this.readyToInitialize && this.initialize()
    },
    fontFamily() {
      this.fetchFont()
    },
    success(val) {
      if (!val) return;

      this.$store.commit("editor/config", {
        tailwindConfig: {fontFamily: {'sans': [this.capitalizedFontFamily]}}
      })
    },
  },
}

</script>
